import { render, staticRenderFns } from "./company_profile.vue?vue&type=template&id=f5a2d8ec&scoped=true&"
import script from "./company_profile.vue?vue&type=script&lang=js&"
export * from "./company_profile.vue?vue&type=script&lang=js&"
import style0 from "./company_profile.vue?vue&type=style&index=0&id=f5a2d8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a2d8ec",
  null
  
)

export default component.exports